import * as fromDatatype from '../../../../models/datatype-library';

export class CouponRedemptionRequestDtoModel {
    guids: string[];
    keyID: string;
    keySecret: string;
  }